module.exports = __webpack_public_path__ + "d7cda798f8739844522d58bb58a9c862.ttf";